import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Divider,
  Group,
  Input,
  Switch,
  Text,
  CloseButton,
  useComputedColorScheme,
  useMantineTheme,
  TextInput,
  Select,
  SelectProps,
  FileButton,
  Chip,
} from "@mantine/core";
import { useMantineColorScheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
  HiArrowDown,
  HiCheck,
  HiClock,
  HiCog,
  HiFolder,
  HiOutlineCloudDownload,
  HiOutlineCog,
  HiOutlineTemplate,
  HiSortAscending,
  HiSortDescending,
  HiTemplate,
} from "react-icons/hi";
import Gallery from "../gallery/Gallery";
import useApi from "../../services/useApi";
import useApiDemo from "../../services/useApiDemo";
import { useAppSelector } from "src/app/hooks";
import { selectCurrentSpace } from "src/state/profile/profileSlice";
import { Settings } from "src/settings";

export default function GeneralGallery(props: { demo?: boolean }) {
  const { setColorScheme, clearColorScheme } = useMantineColorScheme({
    keepTransitions: true,
  });
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  const computedColorScheme = useComputedColorScheme("dark");

  const currentSpace = useAppSelector(selectCurrentSpace);

  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [page, setPage] = useState(0);
  const [initialized, setInitialized] = useState(false);

  const { searchFiles: searchFilesDemo } = useApiDemo();
  const { searchFiles: searchFilesReal } = useApi();

  const searchFiles = (spaceId: string, page: number, pageSize: number = 6) => {
    return props.demo
      ? searchFilesDemo(spaceId, page)
      : searchFilesReal(spaceId, page, pageSize);
  };

  useEffect(() => {
    if (!currentSpace) return;

    searchFiles(currentSpace.id, 0, 5).then((response) => {
      console.log(response);
      setFiles(response);
      setPage(0);
      setInitialized(true);
    });
  }, [currentSpace]);

  const loadMore = () => {
    if (isLoading) return;
    setIsLoading(true);
    searchFiles(currentSpace.id, page + 1).then((response) => {
      setFiles([...files, ...response]);
      // TODO: save data as global state to allow page changes
      setIsLoading(false);
      setPage(page + 1);
    });
  };

  const icons: Record<string, React.ReactNode> = {
    dateCreated: <HiClock />,
  };

  const renderSelectOption: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      {icons[option.value]}
      {option.label}
      {checked && <HiCheck></HiCheck>}
    </Group>
  );

  return (
    <div className="w-full pt-3">
      <div className="flex flex-col overflow-auto w-full">
        <Gallery
          folders={[]}
          files={files}
          loadMoreFn={loadMore}
          onFolderClickFn={() => {}}
          onActionClick={() => {}}
          isSelectionEnabled={false}
          hiddenOptions={true}
          isMiniGallery={true}
          enableInfiniteLoading={false}
          hardcodeSettings={{
            photoAlbum_layout: "rows",
            photoAlbum_spacing: 12,
          } as Settings}
        ></Gallery>
      </div>
    </div>
  );
}
